module.exports = __webpack_public_path__ + "img/logo.86fe2ff5.svg";